angular
  .module('countriesApp')
  .controller('DashboardController', [
    '$location',
    '$scope',
    '$rootScope',
    'SDG',
    'ArticlesService',
    'CompaniesService',
    'ConsultantsService',
    'CountryService',
    'FundingReportsService',
    'JobsService',
    'RoutesService',
    'VisualizationsService',
    'resolvedCountry',
    function (
      $location,
      $scope,
      $rootScope,
      SDG,
      Articles,
      Companies,
      Consultants,
      Country,
      FundingReports,
      Jobs,
      Routes,
      Visualizations,
      resolvedCountry
    ) {
      /**
       * CONTROLLER VARIABLES
       */
      $scope.country = null;
      $scope.articles = null;
      $scope.jobs = null;
      $scope.aggregated_sectors = null;
      $scope.aggregated_donors = null;
      $scope.consultants = null;
      $scope.fundingInfos = null;
      $scope.contracts = null;
      $scope.programs = null;
      $scope.paths = {
        'search': {
          'articles': null,
          'jobs': null,
          'consultants': null,
          'companies': null,
          'funding': {
            'contracts': {
              'generic': Routes.funding_search_path(
                FundingReports.getPathFilters('contract')
              ),
              'countryFiltered': null
            },
            'fundingInfos': {
              'generic': Routes.funding_search_path(
                FundingReports.getPathFilters('funding_info')
              ),
              'countryFiltered': null
            },
            'programs': {
              'generic': Routes.funding_search_path(
                FundingReports.getPathFilters('pipeline')
              ),
              'countryFiltered': null
            }
          }
        },
        'postJob': Routes.job_posting_options_path()
      };
      $scope.sdgList = SDG;
      $scope.isAdmin = $rootScope.admin;
      $scope.emptyChart = 'No results for this country';
      $scope.isExpandedDescription = false;
      $scope.showFeedbackButton = true;

      /**
       * CONTROLLER FUNCTIONS
       */
      /**
       * Toggles the description layout
       *
       * @returns {undefined}
       */
      $scope.expandDescription = () => {
        const isExpanded = $scope.isExpandedDescription;
        $scope.isExpandedDescription = !isExpanded;
      };

      /**
       * Save the user's sharing interaction in our DB
       *
       * @param {string} service - Can be either 'facebook', 'twitter', 'email', 'linkedin', 'print'
       *                           or 'other'
       *
       * @returns {undefined}
       */
      $scope.saveSharingInteraction = service => {
        const params = {
          activity: 'share',
          target_id: $scope.country.id,
          target_type: 'Country',
          detail: service
        };

        $.ajax({'url': Routes.api_activities_path(params), 'type': 'POST'});
      };

      /**
       * Toggles the visibility of the feedback button slideout
       *
       */

      $scope.toggleFeedbackButton = () => {
        $scope.showFeedbackButton = !$scope.showFeedbackButton;
      };

      /**
       * CALLBACK FUNCTIONS
       */
      const callbacks = {};

      /**
       * Stores in the controller the articles retrieved by the BE
       *
       * @param {object} articles - Article Model list
       *
       * @returns {undefined}
       */
      callbacks.articles = articles => {
        $scope.articles = articles;

        if(articles && articles.total) {
          $scope.paths.search.articles += $scope.country.searchParams.articles;
        }
      };

      /**
       * Stores in the controller the jobs retrieved by the BE
       *
       * @param {object} jobs - Job Model list
       *
       * @returns {undefined}
       */
      callbacks.jobs = jobs => {
        $scope.jobs = jobs;

        if(jobs && jobs.total) {
          $scope.paths.search.jobs += $scope.country.searchParams.jobs;
        }
      };

      /**
       * Stores in the controller the consultants retrieved by the BE
       *
       * @param {object} consultants - Consultant Model list
       *
       * @returns {undefined}
       */
      callbacks.consultants = consultants => {
        $scope.consultants = consultants;

        if(consultants && consultants.total) {
          $scope.paths.search.consultants += $scope.country.searchParams.consultants;
        }
      };

      /**
       * Stores in the controller the companies retrieved by the BE
       *
       * @param {object} companies - Organization Model list
       *
       * @returns {undefined}
       */
      callbacks.companies = companies => {
        $scope.companies = companies;

        if(companies && companies.total) {
          $scope.paths.search.companies += $scope.country.searchParams.companies;
        }
      };

      /**
       * Stores in the controller the sectors retrieved by the BE
       *
       * @param {object} sectors - Aggregated sectors
       *
       * @returns {undefined}
       */
      callbacks.sectors = sectors => {
        $scope.aggregated_sectors = sectors;
      };

      /**
       * Stores in the controller the donors retrieved by the BE
       *
       * @param {object} donors - Aggregated donors
       *
       * @returns {undefined}
       */
      callbacks.donors = donors => {
        $scope.aggregated_donors = donors;
      };

      /**
       * Stores in the controller the fundingInfos retrieved by the BE
       *
       * @param {object} fundingInfos - FundingReport Model list
       *
       * @returns {undefined}
       */
      callbacks.fundingInfos = fundingInfos => {
        $scope.fundingInfos = fundingInfos;
      };

      /**
       * Stores in the controller the contracts retrieved by the BE
       *
       * @param {object} contracts - FundingReport Model list
       *
       * @returns {undefined}
       */
      callbacks.contracts = contracts => {
        $scope.contracts = contracts;
      };

      /**
       * Stores in the controller the programs retrieved by the BE
       *
       * @param {object} programs - FundingReport Model list
       *
       * @returns {undefined}
       */
      callbacks.programs = programs => {
        $scope.programs = programs;
      };

      /**
       * Given a valid country, performs all requests for all the data for the dashbaord
       *
       * @param {object} country - Country Model object
       *
       * @returns {undefined}
       */
      const performRequests = country => {
        Articles.get(country.id)
          .then(callbacks.articles);

        Companies.get(country.id)
          .then(callbacks.companies);

        Consultants.get(country.id)
          .then(callbacks.consultants);

        Jobs.get(country.id)
          .then(callbacks.jobs);

        Visualizations.getSectorsByCountry(country.id)
          .then(callbacks.sectors);

        Visualizations.getDonorsByCountry(country.id)
          .then(callbacks.donors);

        FundingReports.getFundingInfosByCountry(country.id)
          .then(callbacks.fundingInfos);

        FundingReports.getContractsByCountry(country.id)
          .then(callbacks.contracts);

        FundingReports.getProgramsByCountry(country.id)
          .then(callbacks.programs);
      };

      /**
       * Resets search paths, stores the resolvedcountry in the scope, fetches header
       * image cloudinary url, sets the funding search paths and adds
       * the bootstrap affix and scrollspy for the internal navigation
       *
       * @param {object} country - Country Model object
       *
       * @returns {undefined}
       */
      const init = country => {
        $scope.paths.search.articles = Routes.news_search_path();
        $scope.paths.search.jobs = Routes.search_jobs_path();
        $scope.paths.search.consultants = Routes.search_people_path();
        $scope.paths.search.companies = Routes.search_organizations_path();

        $scope.country = country;

        performRequests(country);

        $scope.paths.search.funding.contracts.countryFiltered =
          Routes.funding_search_path(
            FundingReports.getPathFilters('contract', country.name)
          );
        $scope.paths.search.funding.fundingInfos.countryFiltered =
          Routes.funding_search_path(
            FundingReports.getPathFilters('funding_info', country.name)
          );
        $scope.paths.search.funding.programs.countryFiltered =
          Routes.funding_search_path(
            FundingReports.getPathFilters('pipeline', country.name)
          );

        $scope.$$postDigest(() => {
          $('body').scrollspy('refresh');
          $('.navigation-bar').affix({offset: {top: $('.navigation-bar').offset().top} });
          // Function for smooth scrolling
          $('a.anchor').on('click', function(event) {
            if (this.hash !== '') {
              event.preventDefault();
              var hash = this.hash;
              $('html, body').animate({
                scrollTop: $(hash).offset().top
              }, 800, function(){
                window.location.hash = hash;
              });
            }
          });
        });
      };

      /**
       * DATA OBTAINING
       */
      init(resolvedCountry);
    }
  ]);
